interface IDurationSegments {
  hours: string;
  minutes: string;
}

const MINUTE_DIGITS = 2;
const HIGHEST_MINUTE_TENS = 5;

export const splitDuration = (value: string): IDurationSegments => {
  const [hours = '', minutes = ''] = value.split(':');
  return { hours, minutes };
};

export const joinDuration = ({ hours, minutes }: IDurationSegments): string =>
  hours === '' && minutes === '' ? '' : `${hours}:${minutes}`;

export const completeDuration = ({ hours, minutes }: IDurationSegments): string =>
  hours === '' && minutes === ''
    ? ''
    : `${hours.padStart(2, '0')}:${minutes.padStart(MINUTE_DIGITS, '0')}`;

export const toHoursSegment = (input: string, maxHours: number): string =>
  input.replace(/\D/g, '').slice(0, String(maxHours).length);

export const toMinutesSegment = (input: string): string => {
  const digits = input.replace(/\D/g, '').slice(0, MINUTE_DIGITS);
  return digits.length === 1 && Number(digits) > HIGHEST_MINUTE_TENS ? `0${digits}` : digits;
};

export const isHoursSegmentFull = (hours: string, maxHours: number): boolean =>
  hours.length >= String(maxHours).length || Number(hours) * 10 > maxHours;

type IKeyPress = Pick<KeyboardEvent, 'key' | 'ctrlKey' | 'metaKey' | 'altKey'>;

export const isSeparatorKey = ({ key, ctrlKey, metaKey, altKey }: IKeyPress): boolean =>
  key.length === 1 && !/\d/.test(key) && !ctrlKey && !metaKey && !altKey;
